import { FilterOption } from '../../../list/interfaces/list-filter/filter-option';
import { TimeFilterOption } from '../../../list/interfaces/timeFilter';


export const ACTIVATION_STATS_VIEW_FILTER_OPTIONS: FilterOption<string>[] = [
  {
    name: 'All',
    value: 'ALL'
  },
  {
    name: 'Success',
    value: 'SUCCESS'
  },
  {
    name: 'Failures',
    value: 'FAILURES'
  }
];

export const ACTIVATION_STATS_TIME_FILTER_OPTIONS: TimeFilterOption[] = [
  {
    name: '2h',
    value: 120
  },
  {
    name: '12h',
    value: 720
  },
  {
    name: '24h',
    value: 1440
  },
  {
    name: 'Last 2 days',
    value: 2880
  },
  {
    name: 'Last 7 days',
    value: 10080
  },
  {
    name: 'Last 15 days',
    value: 21600
  }
  // TODO: enable in next sprint release
  // {
  //   name: 'Last 30 days',
  //   value: 43200
  // }
];

export const ACTIVATION_STATS_DEFAULT_VIEW_FILTER = ACTIVATION_STATS_VIEW_FILTER_OPTIONS[0];
export const ACTIVATION_STATS_DEFAULT_TIME_FILTER = 1440;

export const ACTIVATION_STATS_TIME_FILTER_KEY = 'statsTimeFilter';
export const ACTIVATION_STATS_POLL_PERIOD = 60000;
